
import DashboardLayout from '../pages/Dashboard/Layout/DashboardLayout'

const DynamicReports = () => import('@/pages/DynamicReports')
const DynamicReportExec = () => import('../pages/DynamicReports/Exec')

const dynamicReports = {
  path: '/',
  component: DashboardLayout,
  name: 'DynamicReports',
  title: 'Reportes Dinámicos',
  icon: 'table_chart',
  excludedRoles: [ 'IDEAL' ],
  children: [
    {
      path: '/reports/',
      name: 'Reportes Dinamicos',
      title: 'Reportes Dinámicos',
      component: DynamicReports,
      meta: {
        ifUserCan: {
          view: 'DynamicReports/report',
        },
      },
    },
    {
      path: '/reports/:report/',
      props: true,
      name: 'Ver Reporte',
      component: DynamicReportExec,
      meta: {
        ifUserCan: {
          view: 'DynamicReports/report',
        }
      },
    },
  ],
}

export default dynamicReports



// WEBPACK FOOTER //
// ./src/router/dynamicRoutes.js